// Types
import { ChakraProps } from '@chakra-ui/react';
import { ChartLineStyles } from '@globalTypes/index';

/**
 * Enum representing custom legend styles for the chart.
 */
export enum CustomLegendStyle {
  /**
   * Scatter style for the legend item.
   */
  scatter = 'scatter',

  /**
   * Scatter style for the legend item colored.
   */
  scatterBlue = 'scatterBlue',

  /**
   * Scatter style for the legend item colored.
   */
  scatterYellow = 'scatterYellow',

  /**
   * BlackBase style for the legend item.
   */
  blackBase = 'blackBase',

  /**
   * BlackBaseDashed style for the legend item.
   */
  blackBaseDashed = 'blackBaseDashed',

  /**
   * Dotted style for the legend item.
   */
  blackDotted = 'blackDotted',
}

/**
 * Type alias representing the keys of the 'ChartLineStyles' and 'CustomLegendStyle' enums.
 */
type StyleKeys = keyof typeof ChartLineStyles | keyof typeof CustomLegendStyle;

/**
 * Represents an individual chart legend item.
 */
export type LegendItem = {
  /**
   * The title or label of the chart legend item.
   */
  title: string;

  /**
   * The key representing the style variation of the line for the item.
   */
  styleKey: StyleKeys;
};

/**
 * Type alias representing custom line styles for the chart.
 */
export type CustomLineStyles = Partial<Record<StyleKeys, ChakraProps>>;

/**
 * Represents the props for the ChartLegend component.
 */
export type ChartLegendProps = {
  /**
   * An array of chart legend items, each specifying a title and style variation.
   */
  items: LegendItem[];

  /**
   * Optional custom line styles to be applied to the chart legend items.
   */
  customLineStyles?: CustomLineStyles;
};
